<template>
    <div class="product-preview layout-column noscroll">
        <div class="head">
            <h2>Preview</h2>
            <span class="subheadline">This is how this product will look like in your order form:</span>
        </div>
        <div class="content scroll" style="padding: 30px 20px;">
            <div class="products-list">
              <div class="no-products info-message" v-if="products.length===0">
                <span>No products found in this step</span>
              </div>

              <!-- if it's an order bump -->
              <div class="ob-product alert_box orange"
                   v-if="product.is_ob && step.step_type==1">
                  <span class="icon">
                      <inline-svg :src="require('@/assets/img/alert_icon_yellow.svg')"/>
                  </span>
                <div>
                  <b >"{{product.name}}"</b>
                  <span style="display: block;color: grey;">This is an order bump product no product preview is available,
                  you can control how it looks in the page editor.</span>
                </div>
              </div>

              <!-- if it's not an order form -->
              <div class="no-products alert_box orange" v-if="step.step_type!=1">
                  <span class="icon">
                      <inline-svg :src="require('@/assets/img/alert_icon_yellow.svg')"/>
                  </span>
                <div>
                  <b>No product preview available!</b>
                  <span style="display: block;color: grey;">This step is not an order form,
                    your products presentation can be changed at the page editor.</span>
                </div>
              </div>

                <div v-else class="product-entry layout-column"
                     :style="{'borderColor':getBorderColor(item)}"
                     :class="{
                        'current':item.id===product.id,
                        'highlight':getConfig(item).highlight,
                        'super_highlight':getConfig(item).super_highlight}" v-for="item in products" :key="item.id">
                  <div class="layout-row">
                    <div class="flex-none selection-radio">
                      <svg v-if="item.id===product.id" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="5" fill="#4368E0"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99999 19.1666C4.93738 19.1666 0.833328 15.0626 0.833328 9.99998C0.833328 4.93737 4.93738 0.833313 9.99999 0.833313C15.0626 0.833313 19.1667 4.93737 19.1667 9.99998C19.1667 15.0626 15.0626 19.1666 9.99999 19.1666ZM9.99999 17.5C14.1421 17.5 17.5 14.1421 17.5 9.99998C17.5 5.85784 14.1421 2.49998 9.99999 2.49998C5.85786 2.49998 2.49999 5.85784 2.49999 9.99998C2.49999 14.1421 5.85786 17.5 9.99999 17.5Z" fill="#4368E0"/>
                      </svg>
                      <svg v-else width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99999 19.1666C4.93738 19.1666 0.833328 15.0626 0.833328 9.99998C0.833328 4.93737 4.93738 0.833313 9.99999 0.833313C15.0626 0.833313 19.1667 4.93737 19.1667 9.99998C19.1667 15.0626 15.0626 19.1666 9.99999 19.1666ZM9.99999 17.5C14.1421 17.5 17.5 14.1421 17.5 9.99998C17.5 5.85784 14.1421 2.49998 9.99999 2.49998C5.85786 2.49998 2.49999 5.85784 2.49999 9.99998C2.49999 14.1421 5.85786 17.5 9.99999 17.5Z" fill="#4368E0"/>
                      </svg>
                    </div>
                    <div class="flex layout-column">
                        <span class="top-tag" v-if="getConfig(item).top_tag" :style="{'background':getConfig(item).color}">
                            {{ getConfig(item).top_tag }}
                        </span>
                        <span class="product-name">
                            {{ getProduct(item).name }}
                        </span>
                        <span class="side-tag" :class="{'small':getConfig(item).size==='small'}" v-if="getConfig(item).tag" :style="{'background':getConfig(item).color}">
                            {{ getConfig(item).tag }}
                        </span>
                    </div>
                    <div class="price-cell">
                        {{getPrice(item)}}
                    </div>
                  </div>
                  <div class="funnelish-variants layout-column" v-if="localVariants && product.id===item.id">
                    <div class="funnelish-variant" v-for="variant in localVariants">
                      <div class="variant-header" >
                        <span class="separator"></span>
                        <span class="variant-header-label" style="padding:0 15px;font-size: 14px;">{{ variant.name }}</span>
                      </div>
                      <v-option-switch v-model="variant.value" :value="option.name"
                                       class="variant-option" v-for="(option, index) in variant.options" :label="option.name" :key="index"></v-option-switch>
                    </div>
                  </div>
                </div>
            </div>
        </div>

      <!-- Quick links -->
      <div class="layout-column quick-links-container">
        <div>
          <h1 class="title">Quick links</h1>
        </div>
        <div>
          <ul>
            <li>
              <external-link href="https://docs.funnelish.com/getting-started/step-1-add-your-funnel#step-2-adding-your-products"
                             target="_blank" label="Creating products in Funnelish™"> </external-link>
            </li>
            <li>
              <external-link href="https://docs.funnelish.com/apps/fancify/product-variants"
                             target="_blank" label="Using product variants"> </external-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
import API from "@/api"
import {mapGetters} from "vuex";
import currencies from "@/helpers/currencies";
import VOptionSwitch from "@/components/base/v-option-switch";
import ExternalLink from "@/components/base/external-link";

export default {
    name: "product-preview",
  components: {ExternalLink, VOptionSwitch},
  mixins: [API],
    props:["products", "product", "variants", "step"],

    data() {
        return {
          localVariants: {},
        }
    },
  watch: {
      variants: {
        handler() {
          this.updateVariants()
        },
        deep: true,
      }
  },
    computed: {
      ...mapGetters(['getFunnelStore']),
      currencyCode: function () {
        return this.getFunnelStore.currency_code;
      },
      getSymbol() {
        let target = currencies.find(item => item.id === this.currencyCode);
        if (target) {
          return target.symbol
        } else {
          return "$"
        }
      },
      // Returns current product config
      currentConfig() {
        try {
          return this.product.config ? JSON.parse(this.product.config) : {};
        } catch (e) {
          console.error("Error", e);
          return {};
        }
      }
    },
    methods: {
      updateVariants() {
        let json = JSON.stringify(this.variants);
        let value = JSON.parse(json);
        this.localVariants = value;
      },
      getBorderColor(item) {
        let product = this.getProduct(item);
        if (this.getConfig(product).highlight && this.getConfig(product).color) {
          return this.getConfig(product).color + ' !important';
        } else {
          return 'silver !important';
        }
      },
      getProduct(item) {
        return item.id===this.product.id ? this.product : item;
      },
      getConfig(product) {
        try {
          return this.getProduct(product).config ? JSON.parse(this.getProduct(product).config) : {};
        } catch (e) {
          console.error("Error", e);
          return {};
        }
      },
      getCycleType(type) {
        switch (type) {
          case 2:
            return 'week(s)';
          case 3:
            return 'month(s)';
          case 4:
            return 'year(s)';
          default: // 1 or others
            return 'day(s)'
        }
      },
      getPrice(product) {
        if (!product.is_subscription) { // One time product
          return this.getSymbol + ' ' + product.price;
        } else {
          let cycleType = product.cycle_type;
          let billingAmount = product.billing_amount;
          let cycle = this.getCycleType(cycleType);
          let billingCycle = product.billing_cycle;
          if (billingCycle <= 0)
            billingCycle = ""
          return `${this.getSymbol} ${billingAmount} every ${billingCycle} ${cycle}`;
        }
      }
    },
  created() {
      this.updateVariants();
  }
}
</script>

<style lang="scss" scoped>
.product-preview {

  .head {
    color: black;
    border-bottom: 1px solid #e5e6f1;
    padding: 0 15px 10px;
  }
  .subheadline {
      color: slategrey;
  }
  .content {

  }
  .products-list {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    .ob-product, .no-products {
      padding: 8px;
      position: absolute;
      z-index: 2;
      top: 50%;
      transform: translate(-50%, -50%);
      left: 50%;
      width: 300px;
      font-size: 13px;
    }
    .product-entry {
      border-radius: 5px;
      border: 1px solid silver;
      margin-bottom: 10px;
      padding: 10px 15px;
      opacity: 0.4;
      position: relative;
      overflow: hidden;
      background: white;
      &.current {
        opacity: 1;
      }
      &.super_highlight {
        border: 1px solid #d6cf30 !important;
        box-shadow: 0 4px 9px 1px rgba(0,0,0,0.12) !important;
        background: yellow !important;
        border-radius: 1px !important;
        padding: 20px 20px !important;
        width: 103% !important;
        margin-left: -5px !important;
      }
      .selection-radio {
        display: flex;
        > svg {
          margin: auto 10px auto auto;
        }
      }
      .price-cell {
        width: 25%;
        text-align: end;
        font-weight: 600;
        line-height: 150%;
        margin-right: 15px;
        margin-top: auto;
        margin-bottom: auto;
      }
      .top-tag {
        color: white;
        display: flex;
        z-index: 2;
        text-transform: uppercase;
        line-height: 20px;
        text-align: center;
        background: #f40a0a;
        font-size: 14px;
        width: fit-content;
        padding: 1px 12px;
        border-radius: 2px;
        margin: 0 0 5px;
      }
      .side-tag {
        color: white;
        z-index: 2;
        position: absolute;
        top: 6px;
        right: -16px;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        background: #ca1515;
        line-height: 18px;
        width: 60px;
        text-align: center;
        transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        &.small {
          font-size: 10px;
        }
      }
      .product-name {
        font-size: 15px;
        text-shadow: 0 0 0 rgba(0, 0, 0, 0.13);
        margin: auto 0;
        line-height: 150%;
      }

    }
  }
}
.funnelish-variants {
  display: grid;
  background: inherit;
  flex: 1 1 100%;
  padding-top: 5px;
  >.funnelish-variant {
    display: block;
    background: inherit;
    .variant-header {
      position: relative;
      z-index: 1;
      text-align: center;
      background: inherit;
      margin-bottom: 4px;
      margin-top: 10px;
      .variant-header-label {
        background: inherit;
        position: relative;
      }
    }
    .variant-option {
      position: relative;
      display: block;
      float: left;
      line-height: 1;
      margin: 3px 9px 7px 3px;
    }
    .separator {
      border-top: 1px solid #b3b3b3;
      content: "";
      margin: 0 auto;
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
    }
  }

}
</style>
